module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words.935bd1e2.txt";